import type { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';
import type { AuthAdapter } from '@upme/api-client';
import { routeTree } from '../routeTree.gen';

export interface RouterContext {
  auth: AuthAdapter;
  queryClient: QueryClient;
}

export const router = createRouter({
  routeTree,
  context: undefined as unknown as RouterContext, // injected via RouterProvider
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
  interface StaticDataRouteOption {
    breadcrumb?: string;
  }
}
